export default __webpack_public_path__ + "images/AG.ecf8954.png";